import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';

import SectionTitle from '../shared/SectionTitle';
import Page from '../shared/Page';
import SaveButton from '../shared/SaveButton';
import CancelButton from '../shared/CancelButton';
import RichEditor from '../shared/RichEditor';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import { notifyError, notifyInfo } from '../../utils/notifier';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import withEulaRestrictions from '../license/withEulaRestrictions';
import { DYNAMIC_LAYOUT_ADMINS } from '../../constants/userRoles';
import { PAGE_PATHS, DASHBOARD } from '../../constants/pathsRoots';
import { fetchDefaultValue, updateDefaultValues } from '../../actions/defaultValues/apiRequests';
import SectionDescription from '../shared/SectionDescription';

class DefaultValues extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      initCoverLetter: '',
      coverLetter: '',
      initRetestingGuideline: '',
      retestingGuideline: '',
      initInterpretRadonTestResult: '',
      interpretRadonTestResult: '',
      initLimitOfTestingMeetigationSystemPresent: '',
      limitOfTestingMeetigationSystemPresent: '',
      initLimitOfTestingMeetigationSystemAbsent: '',
      limitOfTestingMeetigationSystemAbsent: '',
    };

    this.onSave = this.onSave.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  static get propTypes() {
    return {
      history: PropTypes.object,
      match: PropTypes.object,
    };
  }

  componentDidMount() {
    fetchDefaultValue().then((values) => {
      this.setState({
        initCoverLetter: values.CoverLetter || '',
        initRetestingGuideline: values.RetestingGuideline || '',
        initInterpretRadonTestResult: values.InterpretRadonTestResult || '',
        initLimitOfTestingMeetigationSystemPresent: values.LimitOfTestingMeetigationSystemPresent || '',
        initLimitOfTestingMeetigationSystemAbsent: values.LimitOfTestingMeetigationSystemAbsent || '',
      });
    });
  }

  actions() {
    const { saving } = this.state;
    return [
      <CancelButton key="cancel" onClick={() => this.props.history.goBack()} />,
      <SaveButton key="save" onClick={this.onSave} loading={saving} disabled={saving} />,
    ];
  }

  onSave() {
    const {
      coverLetter,
      retestingGuideline,
      interpretRadonTestResult,
      limitOfTestingMeetigationSystemPresent,
      limitOfTestingMeetigationSystemAbsent,
    } = this.state;
    this.setState({ saving: true });

    updateDefaultValues({
      CoverLetter: coverLetter,
      RetestingGuideline: retestingGuideline,
      InterpretRadonTestResult: interpretRadonTestResult,
      LimitOfTestingMeetigationSystemPresent: limitOfTestingMeetigationSystemPresent,
      LimitOfTestingMeetigationSystemAbsent: limitOfTestingMeetigationSystemAbsent,
    })
      .then(() => {
        notifyInfo();
        this.setState({ saving: false });
      })
      .catch((error) => {
        notifyError(error);
        this.setState({ saving: false });
      });
  }

  onChange(name, value) {
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  renderImagesNote() {
    return <SectionDescription className="mt-2" description="Only images uploaded from your local drive can be displayed in reports" />;
  }

  render() {
    const {
      initCoverLetter,
      initRetestingGuideline,
      initInterpretRadonTestResult,
      initLimitOfTestingMeetigationSystemPresent,
      initLimitOfTestingMeetigationSystemAbsent,
    } = this.state;
    return (
      <Page
        header="Edit Report Default Values"
        description=""
        actions={this.actions()}
        breadCrumbs={getBreadCrumbs('Edit Report Default Values', location.pathname, [PAGE_PATHS[DASHBOARD]])}
      >
        <Row>
          <Col md={12}>
            <div className="mb-3">
              <SectionTitle title="Cover Letter" key="limitOfTestingMeetigationSystemPresent" />
              <RichEditor initValue={initCoverLetter} onChange={(value) => this.onChange('coverLetter', value)} />
              {this.renderImagesNote()}
            </div>
            <div className="mb-3">
              <SectionTitle title="Suggested Guidelines for Re-Testing" key="limitOfTestingMeetigationSystemPresent" />
              <RichEditor
                initValue={initRetestingGuideline}
                onChange={(value) => this.onChange('retestingGuideline', value)}
              />
              {this.renderImagesNote()}
            </div>
            <div className="mb-3">
              <SectionTitle title="How to Interpret Your Radon Test Results" key="limitOfTestingMeetigationSystemPresent" />
              <RichEditor
                initValue={initInterpretRadonTestResult}
                onChange={(value) => this.onChange('interpretRadonTestResult', value)}
              />
              {this.renderImagesNote()}
            </div>
            <div className="mb-3">
              <SectionTitle
                title="Limit Of Testing: Mitigation System Present"
                key="limitOfTestingMeetigationSystemPresent"
              />
              <RichEditor
                initValue={initLimitOfTestingMeetigationSystemPresent}
                onChange={(value) => this.onChange('limitOfTestingMeetigationSystemPresent', value)}
              />
              {this.renderImagesNote()}
            </div>
            <div className="mb-3">
              <SectionTitle
                title="Limit Of Testing: Mitigation System Is Not Present or Unknown"
                key="limitOfTestingMeetigationSystemAbsent"
              />
              <RichEditor
                initValue={initLimitOfTestingMeetigationSystemAbsent}
                onChange={(value) => this.onChange('limitOfTestingMeetigationSystemAbsent', value)}
              />
              {this.renderImagesNote()}
            </div>
          </Col>
        </Row>
      </Page>
    );
  }
}

export default connect()(withEulaRestrictions(withRoleRestrictions(DefaultValues, DYNAMIC_LAYOUT_ADMINS, false)));



// WEBPACK FOOTER //
// src/components/defaultValues/index.jsx